import { useState, useEffect } from 'react';
import { getProjets, interetProjet, envoyerRetour } from '../api';

/** « Bientôt » : les projets à venir, et « Ça m'intéresse ». Pas de prix, pas de dates. */
const GROUPES = [['en_cours', 'En cours'], ['prevu', 'Prévu'], ['disponible', 'Disponible depuis peu']];

function Suggestion() {
  const [texte, setTexte] = useState(''); const [etat, setEtat] = useState(null);
  if (etat === 'envoye') return <div role="status" style={{ fontSize: 13.5, color: '#22c55e', marginTop: 6 }}>✓ Merci pour votre idée ! Nous la lisons avec attention.</div>;
  return (
    <form onSubmit={async e => { e.preventDefault(); setEtat('envoi'); try { await envoyerRetour({ type: 'idee', message: texte }); setEtat('envoye'); } catch (x) { setEtat(x.message); } }}>
      <textarea value={texte} onChange={e => setTexte(e.target.value)} required minLength={5} maxLength={3000} aria-label="Votre idée"
                placeholder="Une fonctionnalité qui vous manque, une amélioration…"
                style={{ width: '100%', boxSizing: 'border-box', minHeight: 80, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 9, color: 'var(--text)', padding: '9px 11px', fontSize: 14, fontFamily: 'inherit' }} />
      {etat && etat !== 'envoi' && <div style={{ color: 'var(--danger)', fontSize: 13, marginTop: 5 }}>{etat}</div>}
      <button className="btn btn-primary" disabled={etat === 'envoi'} style={{ marginTop: 8 }}>{etat === 'envoi' ? 'Envoi…' : 'Envoyer mon idée'}</button>
    </form>);
}

export default function Bientot({ onFermer }) {
  const [projets, setProjets] = useState(null);
  const [erreur, setErreur] = useState('');
  useEffect(() => { getProjets().then(r => setProjets(r.projets)).catch(e => setErreur(e.message)); }, []);
  useEffect(() => {
    const esc = e => e.key === 'Escape' && onFermer();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onFermer]);
  const basculer = async p => {
    setProjets(l => l.map(x => x.id === p.id ? { ...x, interesse: !x.interesse, interesses: x.interesses !== undefined ? x.interesses + (x.interesse ? -1 : 1) : undefined } : x));
    try { await interetProjet(p.id); } catch (e) { setErreur(e.message); getProjets().then(r => setProjets(r.projets)).catch(() => {}); }
  };
  return (
    <div role="dialog" aria-modal="true" aria-label="Bientôt dans Équipote" onClick={e => e.target === e.currentTarget && onFermer()}
         style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.65)', zIndex: 4000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 560,
                    maxHeight: '86vh', overflowY: 'auto', padding: '18px 18px 26px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <div style={{ fontSize: 19, fontWeight: 800 }}>🗺️ Bientôt dans Équipote</div>
          <button onClick={onFermer} aria-label="Fermer" style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 14, lineHeight: 1.5 }}>
          Les projets en préparation. Dites-nous ce qui vous intéresse : ça nous aide à choisir quoi faire en premier.
        </div>
        {erreur && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{erreur}</div>}
        {!projets && !erreur && <div style={{ color: 'var(--muted)', fontSize: 13 }}>Chargement…</div>}
        {projets && projets.length === 0 && <div style={{ color: 'var(--muted)', fontSize: 13 }}>Aucun projet annoncé pour le moment.</div>}
        {projets && GROUPES.map(([etat, titre]) => {
          const liste = projets.filter(p => p.etat === etat);
          if (!liste.length) return null;
          return (
            <div key={etat} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--accent)', marginBottom: 6 }}>{titre}</div>
              {liste.map(p => (
                <div key={p.id} style={{ border: '1px solid var(--border)', borderRadius: 11, padding: '11px 13px', marginBottom: 7, display: 'flex', gap: 11, alignItems: 'flex-start' }}>
                  <div style={{ fontSize: 22, lineHeight: 1 }}>{p.icone || '✨'}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14.5 }}>{p.titre}</div>
                    {p.description && <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 3, lineHeight: 1.45 }}>{p.description}</div>}
                    <div style={{ marginTop: 8, display: 'flex', gap: 8, alignItems: 'center' }}>
                      {etat === 'disponible'
                        ? <span style={{ fontSize: 12, color: '#22c55e', fontWeight: 700 }}>✓ Disponible</span>
                        : <button type="button" aria-pressed={!!p.interesse} onClick={() => basculer(p)}
                                  style={{ fontSize: 12.5, fontWeight: 700, padding: '5px 11px', borderRadius: 8, cursor: 'pointer',
                                           color: p.interesse ? 'var(--accent-text)' : 'var(--text)', background: p.interesse ? 'var(--accent)' : 'transparent',
                                           border: `1px solid ${p.interesse ? 'var(--accent)' : 'var(--border)'}` }}>
                            {p.interesse ? '✓ Ça m\'intéresse' : '👍 Ça m\'intéresse'}</button>}
                      {p.interesses !== undefined && <span style={{ fontSize: 11.5, color: 'var(--muted)' }}>{p.interesses} intéressé{p.interesses > 1 ? 's' : ''}</span>}
                    </div>
                  </div>
                </div>))}
            </div>);
        })}
        <div style={{ borderTop: '1px solid var(--border)', marginTop: 8, paddingTop: 14 }}>
          <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 4 }}>💡 Une idée pour Équipote ?</div>
          <div style={{ fontSize: 12.5, color: 'var(--muted)', marginBottom: 8 }}>Dites-nous ce qui vous manque : les idées qui reviennent le plus rejoignent cette liste.</div>
          <Suggestion />
        </div>
      </div>
    </div>);
}
